exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".withdraw-custom{width:60%}.withdraw-custom input{width:100%;padding-top:.3rem;padding-bottom:.3rem}.withdraw-custom input::-moz-placeholder{font-size:.85rem}.withdraw-custom input:-ms-input-placeholder{font-size:.85rem}.withdraw-custom input::placeholder{font-size:.85rem}.withdraw-custom input::-webkit-inner-spin-button,.withdraw-custom input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.withdraw-custom input[type=number]{-moz-appearance:textfield}.line-height-2{line-height:2rem}", ""]);

// exports
